import { render, staticRenderFns } from "./CopyableLink.vue?vue&type=template&id=6fd31078&scoped=true&"
import script from "./CopyableLink.vue?vue&type=script&lang=js&"
export * from "./CopyableLink.vue?vue&type=script&lang=js&"
import style0 from "./CopyableLink.vue?vue&type=style&index=0&id=6fd31078&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd31078",
  null
  
)

export default component.exports